<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-loan__tcustsubaccount}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.id" placeholder="id" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('loan:tcustsubaccount:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('loan:tcustsubaccount:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="id" label="主键Id" header-align="center" align="center"></el-table-column>
        <el-table-column prop="userId" label="登录客户编号" header-align="center" align="center"></el-table-column>
        <el-table-column prop="acctType" label="账户类型 1连连支付" header-align="center" align="center"></el-table-column>
        <el-table-column prop="acctStatus" label="账户状态 01正常；02停用" header-align="center" align="center"></el-table-column>
        <el-table-column prop="custType" label="客户类别	1:个人;2:平台;3:公司;" header-align="center" align="center"></el-table-column>
        <el-table-column prop="custName" label="客户姓名" header-align="center" align="center"></el-table-column>
        <el-table-column prop="idType" label="客户证件类型" header-align="center" align="center"></el-table-column>
        <el-table-column prop="idNo" label="客户证件号码" header-align="center" align="center"></el-table-column>
        <el-table-column prop="amount" label="可用现金" header-align="center" align="center"></el-table-column>
        <el-table-column prop="freezeAmt" label="冻结现金" header-align="center" align="center"></el-table-column>
        <el-table-column prop="receivableAmt" label="红包现金" header-align="center" align="center"></el-table-column>
        <el-table-column prop="totalAmt" label="总金额" header-align="center" align="center"></el-table-column>
        <el-table-column prop="platformCode" label="资产方Code" header-align="center" align="center"></el-table-column>
        <el-table-column prop="thirdType" label="第三方类型/资金方Code" header-align="center" align="center"></el-table-column>
        <el-table-column prop="thirdAccount" label="第三方账户编号/客户编号" header-align="center" align="center"></el-table-column>
        <el-table-column prop="accountId" label="存管银行二级电子账户" header-align="center" align="center"></el-table-column>
        <el-table-column prop="bankCode" label="银行编码" header-align="center" align="center"></el-table-column>
        <el-table-column prop="bankName" label="银行名称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="bankCardNo" label="绑定银行卡号" header-align="center" align="center"></el-table-column>
        <el-table-column prop="mobile" label="银行预留手机号码" header-align="center" align="center"></el-table-column>
        <el-table-column prop="email" label="邮箱" header-align="center" align="center"></el-table-column>
        <el-table-column prop="isActivate" label="是否已激活0：未激活；1：已激活" header-align="center" align="center"></el-table-column>
        <el-table-column prop="haveRecord" label="是否有交易记录 0否1是" header-align="center" align="center"></el-table-column>
        <el-table-column prop="lastWdDate" label="上次提现时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="tradeDay" label="交易时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="authorizeOpen" label="开通授权借款人-授权还款；出借人-授权投标" header-align="center" align="center"></el-table-column>
        <el-table-column prop="authorizeDeadline" label="授权期限年月日" header-align="center" align="center"></el-table-column>
        <el-table-column prop="authorizeAmount" label="授权金额" header-align="center" align="center"></el-table-column>
        <el-table-column prop="bindCardStatus" label="是否已经绑卡1-已绑卡有效  0-卡失效" header-align="center" align="center"></el-table-column>
        <el-table-column prop="realNameStatus" label="实名认证 0:未认证 1：实名认证通过 2：实名认证待审核 -1：实名认证未通过" header-align="center" align="center"></el-table-column>
        <el-table-column prop="emailStatus" label="邮箱认证 0:未认证 1：邮箱认证通过" header-align="center" align="center"></el-table-column>
        <el-table-column prop="mobilePhoneStatus" label="手机认证 -1:未通过,0:未认证,1:通过,2:待审核" header-align="center" align="center"></el-table-column>
        <el-table-column prop="spare1" label="备用1" header-align="center" align="center"></el-table-column>
        <el-table-column prop="spare2" label="备用2" header-align="center" align="center"></el-table-column>
        <el-table-column prop="spare3" label="备用3" header-align="center" align="center"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="createBy" label="创建人" header-align="center" align="center"></el-table-column>
        <el-table-column prop="updateTime" label="更新时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="updateBy" label="更新人" header-align="center" align="center"></el-table-column>
        <el-table-column prop="version" label="版本号" header-align="center" align="center"></el-table-column>
        <el-table-column prop="remark" label="备注" header-align="center" align="center"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('loan:tcustsubaccount:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('loan:tcustsubaccount:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './tcustsubaccount-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/loan/tcustsubaccount/page',
        getDataListIsPage: true,
        exportURL: '/loan/tcustsubaccount/export',
        deleteURL: '/loan/tcustsubaccount',
        deleteIsBatch: true
      },
      dataForm: {
        id: ''
      }
    }
  },
  components: {
    AddOrUpdate
  }
}
</script>
